import circleIcon from "../../assets/icons/Ellipse 81.png";
import { Checkbox, PendingTag, SuccessTag, FailedTag } from "../index";
import Table from "../table/Table";
import { useAllGroupExpenses } from "../../data/live";

const displayName = (user, fallback = "Not available") =>
  user?.displayName ||
  [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
  user?.email ||
  fallback;

const formatDate = (value) => {
  if (!value) return "Not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not available";
  return date.toLocaleDateString("en-AU");
};

const money = (amount, currency) =>
  `${Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency || ""}`.trim();

const statusTag = (expense) => {
  const remaining = Number(expense.viewerSummary?.remaining || 0);
  if (remaining === 0) return <SuccessTag tagName="PAID" className="rounded-2" />;
  if (expense.status === "FAILED") return <FailedTag tagName="FAILED" className="rounded-2" />;
  return <PendingTag tagName="OPEN" className="rounded-2" />;
};

const AllExpenses = () => {
  const { items: expenses, loading } = useAllGroupExpenses();
  const allExpenseTableBody = expenses.map((expense) => ({
    expenseDetail: {
      icon: circleIcon,
      name: expense.description,
    },
    createdBy: expense.group?.name || "Not set",
    paidBy: displayName(expense.payer, expense.paidBy),
    lastUpdate: formatDate(expense.updatedAt || expense.date),
    category: expense.category || "Not set",
    tags: Array.isArray(expense.tags) ? expense.tags : [],
    youPaid: money(expense.viewerSummary?.youPaid, expense.currency),
    youLent: money(expense.viewerSummary?.youLent, expense.currency),
    status: statusTag(expense),
  }));

  const allExpenseTableHeader = [
    <Checkbox />,
    "Expense Name",
    "Group",
    "Paid by",
    "Last Update",
    "Category",
    "Tags",
    "You Paid",
    "You Lent",
    "Status",
  ];

  return (
    <>
      <div className="col-12">
        <div className="p-3 px-4 rounded-3 border mt-3">
          {loading ? (
            <div className="p-5 text-center text-muted">Loading group expenses...</div>
          ) : allExpenseTableBody.length ? (
            <Table
              tableBody={allExpenseTableBody}
              tableHeaders={allExpenseTableHeader}
              className={"w-100"}
              AllExpenseTable={true}
            />
          ) : (
            <div className="p-5 text-center text-muted">No group expenses found.</div>
          )}
        </div>
      </div>
    </>
  );
};

export default AllExpenses;
